import { JobStatusResponse } from "../../../../../common/domain/models/job_status_response";
import { IGetFuncionarioAllDocumentosUseCase } from "../../../presentation/useCases/read/get_funcionario_all_documentos_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetFuncionarioAllDocumentosUseCase
 */

export class GetFuncionarioAllDocumentosUseCase implements IGetFuncionarioAllDocumentosUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async getFuncionariosAllDocumentos(
    idFuncionario: number,
  ): Promise<JobStatusResponse> {
    return await this.repository.getFuncionariosAllDocumentos(idFuncionario);
  }
}